import React from 'react';
import { FormField } from 'components/FormField/FormField';
import { PInputText } from 'components/prime/PInputText/PInputText';
import { useCodeframesModalBLoC } from '../../CodeframesModal.bloc';

export const CodeframesModalName: React.FC = () => {
  const { form } = useCodeframesModalBLoC();

  return (
    <FormField
      form={form}
      controller={{
        name: 'name',
        rules: {
          required: 'Name is required',
        },
      }}
      label="Name"
    >
      {({ field, fieldState }) => (
        <PInputText {...field} invalid={fieldState.invalid} maxLength={255} placeholder="Enter a name" />
      )}
    </FormField>
  );
};
